import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as impressions } from '@nerdwallet/nw-client-lib/tracking';
import product from './reducers/product';
import error from './reducers/error';
import redirect from './reducers/redirect';
import componentName from './reducers/componentName';

const combinedReducers = combineReducers({
  routing: routerReducer,
  impressions,
  product,
  redirect,
  componentName,
  error,
});

export default (state = {}, action) => combinedReducers(state, action);
